<div class="container">
  <div class="notification-container">
    <div class="notification-container-view">
      <div nz-row nz-flex style="margin-bottom: 12px">
        <a (click)="onBack()"
           style="color: #2F54EB; text-decoration: none; cursor: pointer; display: inline-flex; align-items: center; gap: 4px;"
           role="button">
          <span nz-icon nzType="left"></span>Back
        </a>
      </div>
      <div>
        <h2 class="mb-12" style="font-size: 24px; font-weight: 600; color: rgba(0, 37, 84, 0.88)">
          {{item.messageTitle}}
        </h2>
        <p style="color: rgba(0, 37, 84, 0.45); margin-bottom: 0">{{ item.createdAt | date: 'd MMMM':'':'en-US' }} at {{ item.createdAt | date: 'h:mma' }}</p>

        <nz-divider class="mt-24 mb-24"></nz-divider>
        <!-- {{item.messageBody}} -->
        <div style="color: rgba(0, 37, 84, 0.88)" [innerHTML]="bodyText"></div>

        <nz-divider class="mt-24 mb-24"></nz-divider>

        <button nz-button nzType="default" *ngIf="isShowApplicationBtn()" [nzLoading]="isLoading" (click)="goToApplication()" style="margin-right: 8px">
          Go to the application
        </button>

        <button nz-button class="bt-bordered" *ngIf="isShowCompanyBtn()" [nzLoading]="isLoading">
          Go to the company
        </button>
      </div>
    </div>
  </div>
</div>
